<template lang="pug">
TheNewsSkeleton(v-if="newsQuery.isPending.value")

TheNotFound(v-else-if="error && error.statusCode === 404")
TheError(
  v-else-if="error"
  title="Failed to load news article."
  :message="error.message"
  :stack="error.stack"
  @retry="newsQuery.refetch"
  @report="() => report(error)"
)

TheNewsView(
  v-else-if="news"
  :body-html="news.ss_body"
  :title="news.ss_title"
  :created="new Date(news.ds_created)"
  :changed="new Date(news.ds_changed)"
)

// TODO: This news item is not available in {{ commentLanguage }}. You can view it in the following languages …

TheNotFound(v-else)
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { injectRequired } from "~/injectRequired";
import { getStringParam } from "~/routing/routes";
import { LogFunctionKey, SolrClientKey } from "~/injectionKeys";
import { useNode } from "~/composables/useNode";
import { useReport } from "~/logging/report";

const report = useReport();

const solrClient = injectRequired(SolrClientKey);
const log = injectRequired(LogFunctionKey);

const i18n = useI18n();
const route = useRoute();

const nid = computed(() => parseInt(getStringParam(route, "nid") || "0") || 0);

const newsQuery = useNode(
  solrClient,
  nid,
  i18n.locale,
  ["ss_title", "ss_body", "ds_changed", "ds_created"],
  "app_news",
  log,
);

const news = computed(() => newsQuery.data.value?.value?.doc);
const availableLanguages = computed(
  () => newsQuery.data.value?.value?.languages ?? [],
);
const error = computed(
  () => newsQuery.error.value ?? newsQuery.data.value?.error,
);

onServerPrefetch(async () => {
  await newsQuery.suspense();
});
</script>
